import Tool, { simpleToolButton } from './Tool';
import { setZoom } from '../utils/zoom';
import Shortcut from '../utils/Shortcut';

class ToolZoomOut extends Tool {
  static toolName = 'Zoom out';
  static shortcut = new Shortcut('-,Shift+-,Cmd+-');

  static action({ controller }) {
    setZoom(controller, controller.canvas.getZoom() * 0.8);
  }

  static enabled({ controller }) {
    return controller.allowPanAndZoom();
  }

  static buttonComponent() {
    return simpleToolButton(ToolZoomOut, 'fa-solid fa-minus');
  }
}

export default ToolZoomOut;
